import styles from '../../../MultiStepPMSLogin.module.scss'
import hub1 from './hub1.png'
import hub2 from './hub2.png'
import hub3 from './hub3.png'

const FindHubId = () => {
  return (
    <div className={styles.solutionContainer}>
      <p className={styles.descriptionText}>
        Best way to get hub id of the hotel is by logging into Opera Cloud. If we have a
        login, this can be done on our side, or through screen share while on a call with
        the hotel.
      </p>
      <p className={styles.descriptionTextEmp}>
        After logging in to Opera Cloud, check out top right corner of the screen and
        click on the hotel name.
      </p>
      <img src={hub1} alt="" />
      <p className={styles.descriptionText}>
        Click on <span className={styles.descriptionTextEmp}>Change Location</span>
      </p>
      <img src={hub2} alt="" />
      <p className={styles.descriptionText}>
        Select <span className={styles.descriptionTextEmp}>Hub</span> from{' '}
        <span className={styles.descriptionTextEmp}>search by</span>, then click the{' '}
        <span className={styles.descriptionTextEmp}>Search</span> button.
      </p>
      <img src={hub3} alt="" />
      <p className={styles.descriptionText}>
        For this example, 19289 is the{' '}
        <span className={styles.descriptionTextEmp}>hub id</span> . Note this value down.
      </p>
    </div>
  )
}

export default FindHubId
